import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadCreatePhotoMutationAtom = createMutationAtomFactory(
  'trade.loadPhotoCreate',
  (params: {
    loadId: string;
    fileName: string;
    fileSize: number;
    mimeType: string;
    isPhotoRequirement?: boolean;
    notes?: string;
    public?: boolean;
  }) => ({
    tradeLoadPhotoCreate: {
      __args: {
        loadId: params.loadId,
        input: {
          fileName: params.fileName,
          fileSize: params.fileSize,
          mimeType: params.mimeType,
          isPhotoRequirement: params.isPhotoRequirement,
          notes: params.notes,
          public: params.public ?? false,
        },
      },
      file: {
        id: true,
        fileName: true,
        fileSize: true,
        mimeType: true,
        status: true,
      },
      uploadUrl: true,
    },
  }),
  { showLoadingOverlay: false },
);
